const apiBaseUrl = process.env.REACT_APP_BE_BASEURL || '';

export const isStudentUnionThs = () => {
  return apiBaseUrl.includes('//ths-backend.');
};

export const isStudentUnionCsu = () => {
  return apiBaseUrl.includes('//csu-backend.');
};

export const useActiveStudentUnion = () => {
  const isThs = isStudentUnionThs();
  const isCsu = isStudentUnionCsu();
  let union = 'UNKNOWN';
  union = isThs ? 'THS' : 'CSU';

  return {
    isThs,
    isCsu,
    union,
  };
};

/*
 * Swaps favicon, app icons, manifest and description to THS when running
 * against the THS backend.
 */
export const applyStudentUnionBranding = () => {
  if (!isStudentUnionThs()) return;

  const publicUrl = process.env.PUBLIC_URL || '';
  const setHref = (selector: string, href: string) => {
    const element = document.querySelector<HTMLLinkElement>(selector);
    if (element) element.href = `${publicUrl}${href}`;
  };

  setHref("link[rel='icon']", '/ths/favicon.ico');
  setHref("link[rel='apple-touch-icon']", '/ths/apple-touch-icon.png');
  setHref("link[rel='manifest']", '/ths/manifest.json');

  document
    .querySelector("meta[name='description']")
    ?.setAttribute(
      'content',
      'Student Union at the Royal Institute of Technology Admin Portal'
    );
};
